<template>
    <div class="tabs-container">
        <DxTabs :data-source="tabs" :selected-index.sync="selectedIndex" @option-changed="onTabChanged"
            :item-template="tabTemplate" orientation="horizontal" />

        <div v-if="selectedIndex === 0" class="tab-content">
            <v-row>
                <v-col cols="7">
                    <GridTarget @selectionChanged="handleSelectionChanged" />
                </v-col>
                <v-col cols="5">
                    <GridTargetPeUserCRM :TargetID="selectedRow" />
                </v-col>
            </v-row>
        </div>
        <div v-if="selectedIndex === 1" class="tab-content">
            <GridDrepturiUtilizatori />
        </div>
        <div v-if="selectedIndex === 2" class="tab-content">
            <GridSalesSources />
        </div>
        <div v-if="selectedIndex === 3" class="tab-content">
            <GridTipuriActivitati />
        </div>
        <div v-if="selectedIndex === 4" class="tab-content">
            <GridKPIAgenti />
        </div>
        <div v-if="selectedIndex === 5" class="tab-content">
            <GridKPIEchipa @selectAgent="onSelectAgent" />
        </div>


    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { DxTabs } from 'devextreme-vue/tabs';
import GridSalesSources from './GridSalesSources.vue';
import GridTipuriActivitati from './GridTipuriActivitati.vue';
import GridDrepturiUtilizatori from './GridDrepturiUtilizatori.vue';
import GridTarget from './GridTarget.vue';
import GridTargetPeUserCRM from './GridTargetPeUserCRM.vue';
import GridKPIAgenti from './GridKPIAgenti.vue';
import GridKPIEchipa from './GridKPIEchipa.vue';

export default defineComponent({
    components: {
        GridSalesSources,
        DxTabs,
        GridTipuriActivitati,
        GridDrepturiUtilizatori,
        GridTarget,
        GridTargetPeUserCRM,
        GridKPIAgenti,
        GridKPIEchipa,
    },
    data() {
        return {
            tabs: [
                { text: 'Target pe utilizatori' },
                { text: 'Drepturi Agenți' },
                { text: 'Surse de vânzare' },
                { text: 'Tipuri Activități' },
                { text: 'Roluri KPI Agenți' },
                { text: 'Raport KPI Echipă' },
            ],
            selectedIndex: 0,
            selectedRow: null as any,
        };
    },
    methods: {
        onTabChanged(e) {
            this.selectedIndex = e.component.option('selectedIndex');

            this.$router.replace({
                query: {
                    ...this.$route.query,
                    mainTab: this.selectedIndex
                }
            }).catch(() => { })
        },
        tabTemplate(itemData, itemIndex, itemElement) {
            return `<div>${itemData.text}</div>`;
        },
        handleSelectionChanged(selectedRow: any) {
            this.selectedRow = selectedRow.ID;
        },
        onSelectAgent(utilizator: string) {
            this.$router.push({ path: '/crm/kpi', query: { utilizator } });
        },
    },
    mounted() {
        if (this.$route.query.mainTab) {
            this.selectedIndex = Number(this.$route.query.mainTab)
        }
    }
});
</script>
<style scoped></style>
